export default __webpack_public_path__ + "static/media/banner.be6e6aac.png";